import { CONTACT_EMAIL } from "../config";
import { LegalMarkdown } from "../lib/markdownLite";
import { Footer } from "./Home";

/* Real content (kb/16 + kb/17, placeholders filled 2026-07-18) — see
   legalContent.ts. Still draft/not lawyer-reviewed; fine for a small guided
   beta, not for a real public launch — kb/16 + kb/17's own "Founder
   checklist" sections track what's still open. */

export function Legal(props: { title: string; content: string; otherHref: string; otherLabel: string }) {
  return (
    <>
      <header className="mx-auto w-full max-w-3xl px-6 py-5">
        <a href="/" className="text-lg font-semibold tracking-wide text-ink">
          Kovrie
        </a>
      </header>
      <main className="mx-auto w-full max-w-3xl px-6 pb-32 pt-12">
        <h1 className="text-3xl font-semibold tracking-tight text-ink">
          {props.title}
        </h1>
        <p className="mt-4 rounded-lg border border-line bg-panel2 px-4 py-3 text-[13px] leading-relaxed text-dim">
          Draft — not yet reviewed by a lawyer. Good faith and accurate as of
          the date below, but treat this as provisional while Kovrie is in
          private beta.
        </p>
        <div className="legal-body">
          <LegalMarkdown content={props.content} />
        </div>
        <p className="mt-10 leading-relaxed text-muted">
          Also see{" "}
          <a href={props.otherHref} className="text-accent underline-offset-2 hover:underline">
            {props.otherLabel}
          </a>
          . Questions?{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-accent">
            {CONTACT_EMAIL}
          </a>
        </p>
      </main>
      <Footer />
    </>
  );
}
